var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button_Gradient',{staticClass:"icon-small",attrs:{"rightIcon":_vm.$icons.DuelsIcons.Accept}},[_vm._v(" "+_vm._s(_vm.$t("duels.accept"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }